import { Button } from "@mui/material"
import { useState } from "react"
import { getAllExpense, getExpenseFilters, getExpenseSort } from "../../api"
import AddPayment from "../modals/AddPayment"
import ExpenseCard from "../cards/ExpenseCard"
import ListData from "../common/ListData"
import { AuthorizedFor } from "../common/AuthorizedFor"
import roles from "../../constants/roles"

const Expenses = () => {
  const [addExpenseModal, setAddExpenseModal] = useState(false)
  const [fetchData, setFetchData] = useState(false)

  const openAddExpense = () => setAddExpenseModal(true)

  const closeAddExpense = () => setAddExpenseModal(false)
  const initialFilters = {
    filter: { self: "beneficiaryId" },
    sort: { field: "creationTimestamp", order: "desc" },
  }

  const CTA = () => (
    <AuthorizedFor roles={[roles.ADMIN, roles.STAFF]}>
      <Button onClick={openAddExpense} variant="contained">
        Add Expense
      </Button>
    </AuthorizedFor>
  )

  return (
    <>
      <ListData
        getFilters={getExpenseFilters}
        getSort={getExpenseSort}
        getAllData={getAllExpense}
        initialFilters={initialFilters}
        HeaderRight={CTA}
        Card={ExpenseCard}
        refresh={fetchData}
        emptyText="No expenses found!"
      />
      <AddPayment
        isExpense={true}
        isOpen={addExpenseModal}
        close={closeAddExpense}
        refresh={() => {
          setFetchData(!fetchData)
        }}
      />
    </>
  )
}

export default Expenses
